export const WAVEFORM_POLL_ID = 'app/common/waveform-poll';
export const TRANSCRIBE_POLL_ID = 'app/common/transcribe-poll';
export const KEYWORD_POLL_ID = 'app/common/keyword-poll';
